export default __webpack_public_path__ + "static/learnplus-manager-c7f078c31dafbbe9c968717e759f079f.png";